<template>
  <div class="login">
    <div class="container">
      <h2>账号密码登录</h2>
      <cus-input
        class="input"
        type="number"
        :rules="{ required: true }"
        v-model="phoneNum"
        placeholder="请输入手机号"
      >
        <template v-slot:icon>
          <img class="icon" src="/images/account/account0.png" alt="">
        </template>
      </cus-input>
      <cus-input
        class="input"
        ref="password"
        :rules="{ required: true }"
        :type="passwordShow ? 'text' : 'password'"
        v-model="password"
        placeholder="请输入密码"
        :maxLength="20"
      >
        <template v-slot:icon>
          <img class="icon" src="/images/account/account1.png" alt="">
        </template>
        <template v-slot:passwordShow>
          <img
            @click="passwordShowFunc"
            class="icon"
            :src="passwordShow ? '/images/account/account3.png' : '/images/account/account2.png'"
            alt=""
          >
        </template>
      </cus-input>
      <cus-button @click="login" class="primary" :disabled="loginDisabled">登录</cus-button>
      <div class="bottom-btn">
        <p class="forget toggle-way">
          <router-link to="reset-password">忘记密码</router-link>
        </p>
        <p @click="toggleLoginWay" class="toggle-way">验证码登录</p>
      </div>
    </div>
    <foot></foot>
  </div>
</template>
<script>
import { Base64 } from 'js-base64';
import { LocalStorageUtil } from '@/utils';
import { mapGetters, mapMutations } from 'vuex';
import { CODE, MESSAGE } from '@/utils/error';
import { wechatSharePkgPage } from '@/mixins/wechatShare.js';
import { resetPswCheck } from '@/utils/login';
import Foot from '@/components/account/footer';

export default {
  mixins: [wechatSharePkgPage],
  components: { Foot },
  data() {
    return {
      phoneNum: '',
      password: '',
      passwordShow: false,
    };
  },
  watch: {
    userInfo: {
      immediate: true,
      handler: function() {
        this.$setShareConfig(this.getShareText());
      },
    },
  },
  computed: {
    ...mapGetters({
      userInfo: 'auth/userInfo',
      contextId: 'auth/contextId',
    }),
    loginDisabled() {
      return this.phoneNum == '' || this.password == '';
    },
  },
  methods: {
    ...mapMutations({
      setLoading: 'setLoadingShow',
    }),
    passwordShowFunc() {
      this.passwordShow = !this.passwordShow;
      this.$refs.password.focus();
    },
    toggleLoginWay() {
      this.$router.replace({ name: 'loginBySMS', query: { replace: true } });
    },
    async login() {
      let params = {
        phoneNum: this.phoneNum,
        passwd: Base64.encode('@GZzib!' + this.password),
        anonymousId: this.$eventTrack.getAnonymousId(),
      };
      if (LocalStorageUtil.getContextId()) {
        params.inviteCode = LocalStorageUtil.getContextId();
      }
      this.setLoading({ show: true });
      let result = await this.$api.account_v1_login_post({
        data: params,
      });
      this.setLoading({ show: false, text: '数据提交中...' });
      if (result) {
        this.$store.commit('auth/accessToken', result.accessToken);
        await this.$store.dispatch('auth/getUserInfo');
        let redirect = this.$route.query.redirect ? decodeURIComponent(this.$route.query.redirect) : false;
        delete this.$route.query.redirect;
        this.$router.replace({
          path: redirect || '/',
          // query: Object.assign({}, this.$route.query)
        });
      }
    },
  },
};
</script>
<style scoped>
.login {
  width: 100vw;
  height: 100vh;
  min-height: 480px;
  display: flex;
  flex-direction: column;
}
.login h2 {
  color: #4e9df6;
  font-size: 30px;
  font-weight: bold;
  padding-bottom: 48px;
}
.login .container {
  padding: 32px 30px;
  box-sizing: border-box;
  /* position: absolute; */
  /* width: 100vw; */
  /* top: 50%;
  left: 50%;
  transform: translate(-50%,-50%) */
}
.login .container .toggle-way {
  margin-top: 17px;
  text-align: right;
  color: #22c5c5;
  font-size: 14px;
}
.login .container .toggle-way a {
  color: #22c5c5;
  font-size: 14px;
}
.login .button {
  margin-top: 48px;
}
.input + .input {
  margin-top: 24px;
}
.login .forget {
  margin-right: auto;
}
.login .forget a {
  color: #74b3fa !important;
  font-size: 14px;
}

.container >>> .cube-validator-msg-def {
  color: #fe2c2a;
  font-size: 12px !important;
  padding-left: 17px;
  line-height: 17px;
  margin-top: 2px;
  display: block;
}
.bottom-btn {
  display: flex;
}
</style>
